/*
The process below uses a mutation observer to check for changes in the DOM, e.g. when
the search results box pops up after a user enters search. It then checks if the search
results box is visible and if it is, it will get the search term and send it off
*/

(function($) {
  $(document).on('ready', function() {
    const resultsContainer = $('#ajaxsearchprores1_1');

    if (resultsContainer.length) {
      const searchObserver = new MutationObserver(function() {
        // If search results container is visible
        if (resultsContainer.css("visibility") == "visible") {
          let searchQuery = $('input[name="phrase"]').val();
          CSAnalytics("Search Made", {"search_query": searchQuery});
        }
      });
      searchObserver.observe(resultsContainer[0], {subtree: true, childList: true});

      resultsContainer.on("click", '.asp_res_url .overlap', function() {
        let result = $(this);
        let analyticsData = {
          content_title   : result.attr("data-title"),
          content_id      : parseInt(result.attr("data-id")),
          author          : result.attr("data-author")
        };
        CSAnalytics("Search Link Clicked", analyticsData);
      })
    }
  })
})(jQuery);
